export var CalToggle;
(function (CalToggle) {
    CalToggle[CalToggle["Open"] = 1] = "Open";
    CalToggle[CalToggle["CloseByDateSel"] = 2] = "CloseByDateSel";
    CalToggle[CalToggle["CloseByCalBtn"] = 3] = "CloseByCalBtn";
    CalToggle[CalToggle["CloseByOutClick"] = 4] = "CloseByOutClick";
    CalToggle[CalToggle["CloseByEsc"] = 5] = "CloseByEsc";
})(CalToggle || (CalToggle = {}));
//# sourceMappingURL=cal-toggle.enum.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/enums/cal-toggle.enum.js
// module id = 571
// module chunks = 10